interface Item {
    Image: string[],
    Price: number,
    Name: string,
    Desc: string
  }

interface ItemMap {
    [key: string]: Item;
}

const items : ItemMap = {
    'j1-concept-1': {
        Image: [
            'https://nashi.com.ua/manager/templates/nashiTpl/images/big_compressed/big-1.jpg',
            'https://nashi.com.ua/manager/templates/nashiTpl/images/big_compressed/big-2.jpg',
            'https://nashi.com.ua/manager/templates/nashiTpl/images/big_compressed/big-detailed.jpg'
        ],
        Price: 4180,
        Name: 'Ноші для евакуації потерпілих типу “Наші Ноші Великі (GS)”.',
        Desc: 'Одні з найкращих рятувальних нош для евакуації потерпілих з різними видами травм. Найкращий варіант для евакуації та проведення рятувальних робіт в умовах обмежених просторів, різноманітного наземного покриття, особливо екстримальних умов, різної кількості людей задіяних в процесі евакуації.\n' +
            '\n' +
            'Революційна конструкція пластикових нош “Наші Ноші Великі (GS)” забезпечує чудовий захист та безпеку пацієнта. Коли людину загортають ноші стають жорсткими. Міцний пластик забезпечує захист евакуйованого та дозволяє виводити його через найскладніші обмежені простори.'
    },
    'j1-concept-2': {
        Image: [
            'https://nashi.com.ua/manager/templates/nashiTpl/images/small_compressed/small-1.jpg',
            'https://nashi.com.ua/manager/templates/nashiTpl/images/small_compressed/small-4.jpg',
            'https://nashi.com.ua/manager/templates/nashiTpl/images/small_compressed/small-detailed.jpg'

        ],
        Price: 2080,
        Name: 'Ноші для евакуації потерпілих типу “Наші Ноші Маленькі (GS)”.',
        Desc: 'Максимально компактні та легкі! Одні з найкращих рятувальних нош для евакуації потерпілих з різними видами травм. Найкращий зменшений та полегшений варіант для евакуації та проведення рятувальних робіт в умовах обмежених просторів, різноманітного наземного покриття, особливо екстримальних умов, різної кількості людей задіяних в процесі евакуації. Міцний пластик забезпечує захист евакуйованого та дозволяє виводити його через найскладніші обмежені простори.'
    }
}


export default items